export enum RegionSettings {
  UpdateRegionSettings = 'regionSettings/UpdateRegionSettings',
  UpdateRegionSettingsSuccess = 'regionSettings/UpdateRegionSettingsSuccess',
  UpdateRegionSettingsFailure = 'regionSettings/UpdateRegionSettingsFailure',
}
